import { createApp } from "vue";
import { createPinia } from "pinia";
import "./style.css";
import "./assets/css/typography.css";
import "./assets/css/fullcalendar.scss";
import "./assets/css/multiselect.scss";
import "./assets/css/modal.scss";
import "./assets/css/svg_icons.css";
import App from "./App.vue";
import Vue3Toastify, { toast } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'
import router from "./router/router.js";
import "./components/Utilities/javascripts/axios";
import VueCookies from "vue-cookies";
import clickOutside from "./components/Utilities/javascripts/clickOutside.js";
import moment from "moment";
import { registerSW } from 'virtual:pwa-register'

registerSW({
  immediate: true,
})
import Input from "./components/Utilities/Input.vue";
import SelectBox from "./components/Utilities/SelectBox.vue";
import SelectBoxComponent from "./components/Utilities/SelectBoxComponent.vue";
import EditAndDelete from "./components/Utilities/EditAndDelete.vue";
import ButtonGroup from "./components/Utilities/dashboard/ButtonGroup.vue";
import CurrentAlert from "./components/Utilities/dashboard/CurrentAlert.vue";
import NewsAlert from "./components/Utilities/dashboard/NewsAlert.vue";
import WeatherDashboard from "./components/Utilities/dashboard/Weather.vue";
import Breadcrumb from "./components/Breadcrumb.vue";
import TableComponent from "./components/TableComponent.vue";
import PaginationComponent from "./components/PaginationComponent.vue";
import SelectDashboard from "./components/Utilities/dashboard/Select.vue";
import SearchDashboard from "./components/Utilities/dashboard/Search.vue";
import Switch from "./components/Utilities/Switch.vue";
import Switch2 from "./components/Utilities/Switch2.vue";
import Radio from "./components/Utilities/Radio.vue";
import ButtonComponent from "./components/ButtonComponent.vue";
import VictimStatusComponent from "./components/VictimStatusComponent.vue";
import NoInfoYetComponent from "./components/NoInfoYetComponent.vue";
import QuantitySelectorComponent from "./components/QuantitySelectorComponent.vue";
import UploadImage from "./components/UploadImage.vue";
import UploadImage2 from "./components/UploadImage2.vue";
import CheckBox from "./components/CheckBoxComponent.vue";
import CheckBox2 from "./components/CheckBoxComponent2.vue";
import SearchBox from "./components/Utilities/SearchBox.vue";
import GenderComponent from "./components/GenderComponent.vue";
import ManualDropdown from "./components/ManualDropdown.vue";
import { globalProperties } from "./GlobalProperties.js";
import NewsAlertHomePage from "./components/Utilities/NewsAlertHomePage.vue";
import Multiselect from "@vueform/multiselect";
import DatePicker from "@/components/Utilities/DatePicker.vue";
import DatePicker2 from "@/components/Utilities/DatePicker2.vue";
import SubCurrentAlert from "./components/Utilities/dashboard/SubCurrentAlert.vue";
import AutoCompleteInput from "@/components/AutoCompleteInput.vue";

//icons
import PasswordIcon from "./assets/icons/password.icon.vue";
import AddIcon from "./assets/icons/add.icon.vue";
import AmbulanceIcon from "./assets/icons/ambulance.icon.vue";
import CaretDownIcon from "./assets/icons/caretDown.icon.vue";
import eyeIcon from "./assets/icons/eye.icon.vue";
import HamburgerIcon from "./assets/icons/hamburger.icon.vue";
import XmarkIcon from "./assets/icons/xmark.icon.vue";
import RainIcon from "./assets/icons/rain.icon.vue";
import MoonIcon from "./assets/icons/moon.icon.vue";
import WaterDropIcon from "./assets/icons/water_drop.icon.vue";
import WindIcon from "./assets/icons/wind.icon.vue";
import CheckTickIcon from "./assets/icons/checkTick.icon.vue";
import InfoIcon from "./assets/icons/info.icon.vue";
import FloodingIcon from "./assets/icons/flooding.icon.vue";
import ExcelIcon from "./assets/icons/excel.icon.vue";
import TrashcanCrossIcon from "./assets/icons/trashcanCross.icon.vue";
import TrashcanIcon from "./assets/icons/trashcan.icon.vue";
import EditIcon from "./assets/icons/edit.icon.vue";
import CloseIcon from "./assets/icons/close.icon.vue";
import DisasterIcon from "./assets/icons/Disaster.icon.vue";
import DisasterIcon2 from "./assets/icons/DisasterII.icon.vue";
import ShelterIcon from "./assets/icons/Shelter.icon.vue";
import MedicalKitIcon from "./assets/icons/medical_kit.icon.vue";
import OfficerIcon from "./assets/icons/officer.icon.vue";
import VictimIcon from "./assets/icons/Victim.icon.vue";
import CheckUpIcon from "./assets/icons/checkup.icon.vue";
import EmergencyReqIcon from "./assets/icons/emergency_req.icon.vue";
import ResourcesIcon from "./assets/icons/Resource.icon.vue";
import PublicRelationIcon from "./assets/icons/public_relation.icon.vue";
import TakeOutIcon from "./assets/icons/takeOut.icon.vue";
import TakeInIcon from "./assets/icons/takeIn.icon.vue";
import TransferIcon from "./assets/icons/transfer.icon.vue";
import CalendarIcon from "./assets/icons/calendar.icon.vue";
import SearchIcon from "./assets/icons/search.icon.vue";
import HelpIcon from "./assets/icons/help.icon.vue";
import CheckTickCompleteIcon from "./assets/icons/CheckTickComplete.icon.vue";
import RequestResourcesIcon from "./assets/icons/requestResources.icon.vue";
import WorkFlowChartIcon from "./assets/icons/workFlowChart.icon.vue";
import HeartIcon from "./assets/icons/heart.icon.vue";
import MinusIcon from "./assets/icons/minus.icon.vue";
import PopulationIcon from "./assets/icons/population.icon.vue";
import SearchNotFoundIcon from "./assets/icons/searchNotFound.icon.vue";
import MedicalIcon from "./assets/icons/Medical.icon.vue";
import WorldIcon from "./assets/icons/world.icon.vue";
import UpdateIcon from "./assets/icons/update.icon.vue";
import ErrorIcon from "./assets/icons/error.icon.vue";
import XIcon from "./assets/icons/x.icon.vue";
import AlertIcon from "./assets/icons/Alert.icon.vue";
import AccountIcon from "./assets/icons/account.icon.vue";
import RefreshIcon from "./assets/icons/refresh.icon.vue";
import DownloadIcon from "./assets/icons/download.icon.vue";
import TableIcon from "./assets/icons/table.icon.vue";

// import ShieldTickIcon from './assets/icons/ShieldAndTick.icon.vue'

//cards
import PublicRelationsCard from "./components/Cards/PublicRelationsCard.vue";
import ScheduleCard from "./components/Cards/ScheduleCard.vue";
//modals
import StatusModal from "./components/Modals/StatusModal.vue";
import AddShelterInfoModal from "./components/Modals/AddShelterInfoModal.vue";
import CheckVictimsInfoModal from "./components/Modals/CheckVictimsInfoModal.vue";
import AddPublicRelationsModal from "./components/Modals/AddPublicRelationsModal.vue";
import SelectFieldTeamModal from "./components/Modals/SelectFieldTeamModal.vue";
import SelectFieldShelterModal from "./components/Modals/SelectFieldShelterModal.vue";
import TransferCaregiverModal from "./components/Modals/TransferCaregiverModal.vue";
import AddDepartment from "./components/Modals/AddDepartment.vue";
import AddPosition from "./components/Modals/AddPosition.vue";
import OrganizeDutiesInShelterModal from "./components/Modals/OrganizeDutiesInShelterModal.vue";
import HistoryAssessmentModal from "./components/Modals/HistoryAssessmentModal.vue";
import LogHistoryAssessmentModal from "./components/Modals/LogHistoryAssessmentModal.vue";
import TransferVictimModal from "./components/Modals/TransferVictimModal.vue";
import TeamNomalUserModal from "./components/Modals/TeamNomalUserModal.vue";
import ShelterStaffInfoModal from "./components/Modals/ShelterStaffInfoModal.vue";
import WorkFlowChartModal from "./components/Modals/WorkFlowChartModal.vue";
import AlertAnnounceModal from "./components/Modals/AlertAnnounceModal.vue";
import AddResourceToShelterModal from "./components/Modals/AddResourceToShelterModal.vue";
import RequestResourcesListModal from "./components/Modals/RequestResourcesListModal.vue";
import ResourceRequestHistoryDetailModal from "./components/Modals/ResourceRequestHistoryDetailModal.vue";
import ResourceImportExportHistoryDetailModal from "./components/Modals/ResourceImportExportHistoryDetailModal.vue";
import ResourceImportExportHistoryModal from "./components/Modals/ResourceImportExportHistoryModal.vue";
import ResourceRequestHistoryModal from "./components/Modals/ResourceRequestHistoryModal.vue";
import TransferResourceModal from "./components/Modals/TransferResourceModal.vue";
import ResourceTransferHistoryDetailModal from "./components/Modals/ResourceTransferHistoryDetailModal.vue";
import ResourceTransferHistoryModal from "./components/Modals/ResourceTransferHistoryModal.vue";
import RequestResourceModal from "./components/Modals/RequestResourceModal.vue";
import ImageModal from "./components/Modals/ImageModal.vue";
import IncreaseResourcesModal from "./components/Modals/IncreaseResourcesModal.vue";
import DecreaseResourcesModal from "./components/Modals/DecreaseResourcesModal.vue";
import ResourcesDetailModal from "./components/Modals/ResourcesDetailModal.vue";
import EditRequestResourceModal from "./components/Modals/EditRequestResourceModal.vue";
import UpdateRequestResourceModal from "./components/Modals/UpdateRequestResourceModal.vue";
import AddResourceModal from "./components/Modals/AddResourceModal.vue";
import ResourceTypeListModal from "./components/Modals/ResourceTypeListModal.vue";
import AddResourceTypeModal from "./components/Modals/AddResourceTypeModal.vue";
import ResourceClassifierListModal from "./components/Modals/ResourceClassifierListModal.vue";
import AddResourceClassifierModal from "./components/Modals/AddResourceClassifierModal.vue";
import EdiResourcesModal from "./components/Modals/EdiResourcesModal.vue";
import HistoryUpdateDisasterModal from "./components/Modals/HistoryUpdateDisasterModal.vue";
import HistoryDisasterModal from "./components/Modals/HistoryDisasterModal.vue";
import NotificationModal from "./components/Modals/NotificationModal.vue";
import VulnerableGroupListModal from "./components/Modals/VulnerableGroupListModal.vue";
import AddVulnerableGroupModal from "./components/Modals/AddVulnerableGroupModal.vue";
import DownloadReportModal from "./components/Modals/DownloadReportModal.vue";
import TransferResourceSpecialModal from "./components/Modals/TransferResourceSpecialModal.vue";
import TransferResourceOneAddModal from "./components/Modals/TransferResourceOneAddModal.vue";
import OfflineInfo from "./components/Modals/OfflineInfo.vue";


const pinia = createPinia();
const app = createApp(App);
globalProperties(app);
// app.use(Vue3Toastify, {
//   position: 'top-right',
//   theme: 'dark',
//   // autoClose: 3000,
// })

app.config.globalProperties.$moment = moment;

//icons
app
  .component("AddIcon", AddIcon)
  .component("AmbulanceIcon", AmbulanceIcon)
  .component("CaretDownIcon", CaretDownIcon)
  .component("PasswordIcon", PasswordIcon)
  .component("eyeIcon", eyeIcon)
  .component("HamburgerIcon", HamburgerIcon)
  .component("XmarkIcon", XmarkIcon)
  .component("RainIcon", RainIcon)
  .component("MoonIcon", MoonIcon)
  .component("WaterDropIcon", WaterDropIcon)
  .component("WindIcon", WindIcon)
  .component("CheckTickIcon", CheckTickIcon)
  .component("InfoIcon", InfoIcon)
  .component("FloodingIcon", FloodingIcon)
  .component("ExcelIcon", ExcelIcon)
  .component("TrashcanCrossIcon", TrashcanCrossIcon)
  .component("TrashcanIcon", TrashcanIcon)
  .component("EditIcon", EditIcon)
  .component("CloseIcon", CloseIcon)
  .component("DisasterIcon", DisasterIcon)
  .component("DisasterIcon2", DisasterIcon2)
  .component("ShelterIcon", ShelterIcon)
  .component("MedicalKitIcon", MedicalKitIcon)
  .component("EmergencyReqIcon", EmergencyReqIcon)
  .component("VictimIcon", VictimIcon)
  .component("CheckUpIcon", CheckUpIcon)
  .component("OfficerIcon", OfficerIcon)
  .component("ResourcesIcon", ResourcesIcon)
  .component("PublicRelationIcon", PublicRelationIcon)
  .component("TakeOutIcon", TakeOutIcon)
  .component("TakeInIcon", TakeInIcon)
  .component("TransferIcon", TransferIcon)
  .component("CalendarIcon", CalendarIcon)
  .component("SearchIcon", SearchIcon)
  .component("HelpIcon", HelpIcon)
  .component("CheckTickCompleteIcon", CheckTickCompleteIcon)
  .component("RequestResourcesIcon", RequestResourcesIcon)
  .component("WorkFlowChartIcon", WorkFlowChartIcon)
  .component("HeartIcon", HeartIcon)
  .component("MinusIcon", MinusIcon)
  .component("PopulationIcon", PopulationIcon)
  .component("SearchNotFoundIcon", SearchNotFoundIcon)
  .component("MedicalIcon", MedicalIcon)
  .component("WorldIcon", WorldIcon)
  .component("UpdateIcon", UpdateIcon)
  .component("ErrorIcon", ErrorIcon)
  .component("XIcon", XIcon)
  .component("AlertIcon", AlertIcon)
  .component("AccountIcon", AccountIcon)
  .component("RefreshIcon", RefreshIcon)
  .component("DownloadIcon", DownloadIcon)
  .component("TableIcon", TableIcon);
//components
app
  .component("Input", Input)
  .component("SelectBox", SelectBox)
  .component("SelectBoxComponent", SelectBoxComponent)
  .component("DatePicker", DatePicker)
  .component("DatePicker2", DatePicker2)
  .component("EditAndDelete", EditAndDelete)
  .component("ButtonGroup", ButtonGroup)
  .component("CurrentAlert", CurrentAlert)
  .component("NewsAlert", NewsAlert)
  .component("WeatherDashboard", WeatherDashboard)
  .component("Breadcrumb", Breadcrumb)
  .component("TableComponent", TableComponent)
  .component("PaginationComponent", PaginationComponent)
  .component("SearchDashboard", SearchDashboard)
  .component("Switch", Switch)
  .component("Switch2", Switch2)
  .component("Radio", Radio)
  .component("ButtonComponent", ButtonComponent)
  .component("VictimStatusComponent", VictimStatusComponent)
  .component("NoInfoYetComponent", NoInfoYetComponent)
  .component("QuantitySelectorComponent", QuantitySelectorComponent)
  .component("UploadImage", UploadImage)
  .component("UploadImage2", UploadImage2)
  .component("SelectDashboard", SelectDashboard)
  .component("CheckBox", CheckBox)
  .component("CheckBox2", CheckBox2)
  .component("SearchBox", SearchBox)
  .component("GenderComponent", GenderComponent)
  .component("ManualDropdown", ManualDropdown)
  .component("NewsAlertHomePage", NewsAlertHomePage)
  .component("Multiselect", Multiselect)
  .component("AutoCompleteInput", AutoCompleteInput)
  .component("SubCurrentAlert", SubCurrentAlert)
  .component("OfflineInfo", OfflineInfo);

//cards
app
  .component("PublicRelationsCard", PublicRelationsCard)
  .component("ScheduleCard", ScheduleCard);

//modals
app
  .component("StatusModal", StatusModal)
  .component("AddShelterInfoModal", AddShelterInfoModal)
  .component("CheckVictimsInfoModal", CheckVictimsInfoModal)
  .component("AddPublicRelationsModal", AddPublicRelationsModal)
  .component("SelectFieldTeamModal", SelectFieldTeamModal)
  .component("SelectFieldShelterModal", SelectFieldShelterModal)
  .component("TransferCaregiverModal", TransferCaregiverModal)
  .component("AddDepartment", AddDepartment)
  .component("AddPosition", AddPosition)
  .component("OrganizeDutiesInShelterModal", OrganizeDutiesInShelterModal)
  .component("TransferVictimModal", TransferVictimModal)
  .component("HistoryAssessmentModal", HistoryAssessmentModal)
  .component("LogHistoryAssessmentModal", LogHistoryAssessmentModal)
  .component("TeamNomalUserModal", TeamNomalUserModal)
  .component("WorkFlowChartModal", WorkFlowChartModal)
  .component("ShelterStaffInfoModal", ShelterStaffInfoModal)
  .component("AlertAnnounceModal", AlertAnnounceModal)
  .component("AddResourceToShelterModal", AddResourceToShelterModal)
  .component("RequestResourcesListModal", RequestResourcesListModal)
  .component("ResourceRequestHistoryDetailModal", ResourceRequestHistoryDetailModal)
  .component("ResourceImportExportHistoryDetailModal", ResourceImportExportHistoryDetailModal)
  .component("ResourceImportExportHistoryModal", ResourceImportExportHistoryModal)
  .component("ResourceRequestHistoryModal", ResourceRequestHistoryModal)
  .component("TransferResourceModal", TransferResourceModal)
  .component("ResourceTransferHistoryDetailModal", ResourceTransferHistoryDetailModal)
  .component("ResourceTransferHistoryModal", ResourceTransferHistoryModal)
  .component("RequestResourceModal", RequestResourceModal)
  .component("ImageModal", ImageModal)
  .component("IncreaseResourcesModal", IncreaseResourcesModal)
  .component("DecreaseResourcesModal", DecreaseResourcesModal)
  .component("ResourcesDetailModal", ResourcesDetailModal)
  .component("EditRequestResourceModal", EditRequestResourceModal)
  .component("UpdateRequestResourceModal", UpdateRequestResourceModal)
  .component("AddResourceModal", AddResourceModal)
  .component("ResourceTypeListModal", ResourceTypeListModal)
  .component("AddResourceTypeModal", AddResourceTypeModal)
  .component("ResourceClassifierListModal", ResourceClassifierListModal)
  .component("AddResourceClassifierModal", AddResourceClassifierModal)
  .component("EdiResourcesModal", EdiResourcesModal)
  .component("HistoryUpdateDisasterModal", HistoryUpdateDisasterModal)
  .component("HistoryDisasterModal", HistoryDisasterModal)
  .component("NotificationModal", NotificationModal)
  .component("VulnerableGroupListModal", VulnerableGroupListModal)
  .component("AddVulnerableGroupModal", AddVulnerableGroupModal)
  .component("DownloadReportModal", DownloadReportModal)
  .component("TransferResourceSpecialModal", TransferResourceSpecialModal)
  .component("TransferResourceOneAddModal", TransferResourceOneAddModal)

//plugins
app.use(pinia).use(VueCookies).use(router);

// fun
//directives
app.directive("click-outside", clickOutside);

app.mount("#app");
